import { useAuthContext } from "components/context/authContext";
import MbFooter from "./footerMb";
import WebFooter from "./footerWeb";
import { timeFormat } from "util/commAction";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { lodNo } = useParams();
  const { viewPort, lodInf } = useAuthContext();
  const isHidden = pathname.includes("login") || pathname.includes("join");

  // const lodInfo =
  //   pathname === "/"
  //     ? {
  //         lodNm: t("txt_ft_srvc"),
  //         ceoNm: t("txt_ft_ceoNm_cmm"),
  //         lodAddr: t("txt_ft_addr_cmm"),
  //         bizNm: t("txt_ft_bizNm"),
  //         bizNo: t("txt_ft_bizNo_cmm"),
  //         mailOrdrBizNo: t("txt_ft_mailOrdrBizNo_cmm"),
  //         telNo: t("txt_ft_tl_cmm"),
  //         lodEml: t("txt_ft_eml_cmm"),
  //       }
  //     : lodInf;

  const lodInfo = {
    lodNm: t("txt_lodNm"),
    ceoNm: t("txt_ceoNm"),
    lodAddr: t("txt_lodAddr"),
    bizNm: t("txt_bizNm"),
    bizNo: t("txt_bizNo"),
    mailOrdrBizNo: t("txt_mailOrdrBizNo"),
    telNo: t("txt_telNo"),
    lodEml: t("txt_lodEml"),
  };

  return (
    <footer hidden={isHidden}>
      {pathname === "/" + lodNo && (
        <div className="flex gap-2 mt-[4rem] mb-6 ">
          <h5 className="font-font-B">{t("txt_lod_ti_inf")}&nbsp;:&nbsp;</h5>
          <h5>
            {t("sb_ttl_hm_chckIn")}&nbsp;{timeFormat(lodInf?.chkInTi ?? "-")}
          </h5>
          <span>{"/"}</span>
          <h5>
            {t("sb_ttl_hm_chckOut")}&nbsp;{timeFormat(lodInf?.chkOutTi ?? "-")}
          </h5>
        </div>
      )}
      {viewPort?.screen === "web" && <WebFooter lodInf={lodInfo} />}
      {viewPort?.screen === "mb" && <MbFooter lodInf={lodInfo} />}
    </footer>
  );
}
